var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagType,_vm._g(_vm._b({ref:"tile",tag:"component",class:[("cv-tile " + _vm.carbonPrefix + "--tile"), ( _obj = {}, _obj[(_vm.carbonPrefix + "--tile--light")] = _vm.isLight, _obj )],attrs:{"checked":_vm.selected,"expanded":_vm.expanded}},'component',_vm.$attrs,false),_vm.$listeners),[[_vm._t("default")],_c('template',{slot:"below"},[_vm._t("below")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }